import { render, staticRenderFns } from "./CreateTQF.vue?vue&type=template&id=5334710c&"
import script from "./CreateTQF.vue?vue&type=script&lang=js&"
export * from "./CreateTQF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports